/**
 * Pressed to the Edge — Theme JS
 * Handles: cart drawer, mobile nav, toast notifications, cart count
 */

(function () {
  'use strict';

  // ── Cart Drawer ────────────────────────────────────────────────
  const cartDrawer    = document.getElementById('cart-drawer');
  const cartOverlay   = document.getElementById('cart-overlay');
  const cartClose     = document.getElementById('cart-close');
  const cartItemsEl   = document.getElementById('cart-items');
  const cartTotalEl   = document.getElementById('cart-total');
  const cartCountEls  = document.querySelectorAll('[data-cart-count]');
  const cartEmptyEl   = document.getElementById('cart-empty');
  const cartFooterEl  = document.getElementById('cart-footer');

  function openCart() {
    if (!cartDrawer) return;
    cartDrawer.classList.add('is-open');
    cartOverlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    fetchCart();
  }

  function closeCart() {
    if (!cartDrawer) return;
    cartDrawer.classList.remove('is-open');
    cartOverlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  if (cartClose)   cartClose.addEventListener('click', closeCart);
  if (cartOverlay) cartOverlay.addEventListener('click', closeCart);

  document.querySelectorAll('[data-open-cart]').forEach(el => {
    el.addEventListener('click', openCart);
  });

  async function fetchCart() {
    try {
      const res  = await fetch('/cart.js');
      const cart = await res.json();
      renderCart(cart);
    } catch (e) {
      console.error('[Theme] Cart fetch error', e);
    }
  }

  function formatMoney(cents, currency) {
    return new Intl.NumberFormat('pl-PL', {
      style: 'currency',
      currency: currency || 'PLN',
      minimumFractionDigits: 2
    }).format(cents / 100);
  }

  function renderCart(cart) {
    // Update count badges
    const count = cart.item_count;
    cartCountEls.forEach(el => {
      el.textContent = count;
      el.style.display = count > 0 ? '' : 'none';
    });

    if (!cartItemsEl) return;

    if (count === 0) {
      if (cartEmptyEl)  cartEmptyEl.style.display  = '';
      if (cartFooterEl) cartFooterEl.style.display  = 'none';
      cartItemsEl.innerHTML = '';
      return;
    }

    if (cartEmptyEl)  cartEmptyEl.style.display  = 'none';
    if (cartFooterEl) cartFooterEl.style.display  = '';

    cartItemsEl.innerHTML = cart.items.map(item => {
      const isCampaign = item.properties && item.properties['_press_it_campaign'];
      return `
        <div class="cart-item">
          ${item.featured_image
            ? `<img class="cart-item__img" src="${item.featured_image.url}" alt="${item.title}" width="64" height="64">`
            : `<div class="cart-item__img" style="background:var(--c-surface-2);display:flex;align-items:center;justify-content:center;font-size:1.5rem;opacity:0.2;">♪</div>`
          }
          <div>
            <div class="cart-item__name">${item.product_title}</div>
            <div class="cart-item__sub">${(item.variant_title && item.variant_title !== 'Default Title') ? item.variant_title + ' · ' : ''}Qty ${item.quantity}</div>
            ${isCampaign ? `<span class="cart-item__badge">Pre-order</span>` : ''}
          </div>
          <div class="cart-item__price">${formatMoney(item.final_line_price, cart.currency)}</div>
        </div>
      `;
    }).join('');

    if (cartTotalEl) {
      cartTotalEl.textContent = formatMoney(cart.total_price, cart.currency);
    }
  }

  // Listen for Press It cart updates
  document.addEventListener('press-it:cart-updated', () => {
    openCart();
  });

  // ── Mobile Nav ─────────────────────────────────────────────────
  const burger  = document.getElementById('nav-burger');
  const mobileNav = document.getElementById('mobile-nav');

  if (burger && mobileNav) {
    burger.addEventListener('click', () => {
      const open = mobileNav.classList.toggle('is-open');
      burger.setAttribute('aria-expanded', open);
      document.body.style.overflow = open ? 'hidden' : '';
    });
  }

  // ── Toast ──────────────────────────────────────────────────────
  window.showToast = function(msg, color) {
    let toast = document.getElementById('site-toast');
    if (!toast) {
      toast = document.createElement('div');
      toast.id = 'site-toast';
      toast.className = 'toast';
      document.body.appendChild(toast);
    }
    toast.textContent = msg;
    toast.style.color = color === 'amber' ? 'var(--c-amber)' : color === 'green' ? 'var(--c-success)' : '';
    void toast.offsetWidth;
    toast.classList.add('is-visible');
    clearTimeout(toast._t);
    toast._t = setTimeout(() => toast.classList.remove('is-visible'), 3200);
  };

  // ── Init cart count on load ────────────────────────────────────
  fetchCart();

})();
